import { jwtDecode } from 'jwt-decode'
import { useState } from 'react'

import type { AuthToken, DecodedAuthToken } from '../EntriContext.types'
import { useGetEntriAuthTokenMutation } from '../queries/useGetEntriAuthTokenMutation'

const decodeAuthToken = (encodedToken: string) => jwtDecode<DecodedAuthToken>(encodedToken)

export const useGetAuthToken = () => {
  const [authToken, setAuthToken] = useState<AuthToken | null>(null)
  const { entriAuthTokenMutation } = useGetEntriAuthTokenMutation()

  const getAuthToken = async () => {
    const isTokenValid = !!authToken && authToken.exp > Math.floor(Date.now() / 1000)

    if (isTokenValid) {
      return authToken
    }

    try {
      const { authToken: encodedToken } = await entriAuthTokenMutation.mutateAsync([])
      const decodedToken = decodeAuthToken(encodedToken)

      const newAuthToken = {
        token: encodedToken,
        ...decodedToken,
      }

      setAuthToken(newAuthToken)

      return newAuthToken
    } catch (e) {
      throw new Error('Unable to get auth token')
    }
  }

  return { getAuthToken }
}
